import { render } from "./MaterialsList.vue?vue&type=template&id=52b43832"
import script from "./MaterialsList.vue?vue&type=script&lang=js"
export * from "./MaterialsList.vue?vue&type=script&lang=js"

import "./MaterialsList.vue?vue&type=style&index=0&id=52b43832&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__